export default __webpack_public_path__ + "static/media/charco-inbox.ea2087d7.svg";